import { cloneElement } from 'react'
import { usePermissions } from 'react-admin';

const Permission = ({ permission = '', children, defaultElement = null, ...props }) => {
  const { permissions } = usePermissions();
  return permissions && permissions.includes(permission) ? cloneElement(children, props) : defaultElement;
}
export default Permission;